var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReliability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00048 14.7497C3.81125 14.7503 3.62571 14.6973 3.46543 14.5967C3.30516 14.496 3.17671 14.352 3.09503 14.1813C3.01335 14.0106 2.98177 13.8203 3.00398 13.6323C3.02619 13.4444 3.10126 13.2666 3.22048 13.1197L13.1205 2.91967C13.1947 2.83396 13.2959 2.77603 13.4075 2.75541C13.519 2.73478 13.6342 2.75269 13.7342 2.80618C13.8342 2.85967 13.9131 2.94557 13.9578 3.04978C14.0026 3.15399 14.0106 3.27032 13.9805 3.37967L12.0605 9.39967C12.0039 9.5512 11.9849 9.71419 12.0051 9.87468C12.0253 10.0352 12.0841 10.1884 12.1766 10.3211C12.269 10.4538 12.3923 10.5622 12.5358 10.6368C12.6793 10.7115 12.8387 10.7502 13.0005 10.7497H20.0005C20.1897 10.749 20.3752 10.8021 20.5355 10.9027C20.6958 11.0033 20.8242 11.1473 20.9059 11.318C20.9876 11.4887 21.0192 11.6791 20.997 11.867C20.9748 12.0549 20.8997 12.2327 20.7805 12.3797L10.8805 22.5797C10.8062 22.6654 10.705 22.7233 10.5935 22.7439C10.482 22.7646 10.3668 22.7467 10.2668 22.6932C10.1667 22.6397 10.0879 22.5538 10.0431 22.4496C9.9984 22.3454 9.9904 22.229 10.0205 22.1197L11.9405 16.0997C11.9971 15.9482 12.0161 15.7852 11.9959 15.6247C11.9757 15.4642 11.9168 15.311 11.8244 15.1782C11.732 15.0455 11.6087 14.9372 11.4652 14.8625C11.3217 14.7879 11.1622 14.7491 11.0005 14.7497H4.00048Z",
    stroke: "#009CC5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReliability);
export default __webpack_public_path__ + "static/media/reliability.842a7813ae867b83e553e3772ff27b6a.svg";
export { ForwardRef as ReactComponent };